import React from 'react';
import TableDatePicker from 'ui/TableInputs/TableDatePicker/TableDatePicker';
import Input, { AmountInput, Select, SelectItem, Textarea } from 'ui/Input';
import { IAccount } from 'store/accounts.model';
import { TransferFrequencyList } from 'utils/constants';
import { IBank, IFormValues, ITransfersState } from './ScheduledTransfers.model';

const renderSourceAccountField = (accounts: IAccount[]) => (
  <Select name="sourceAccount" label="Source Account" disabled>
    {accounts.map(({ accountNumber }) => (
      <SelectItem value={accountNumber} key={accountNumber}>
        {accountNumber}
      </SelectItem>
    ))}
  </Select>
);

const renderAmountField = () => <AmountInput name="amount" label="Amount" disabled />;

// const renderDestinationAccountField = (accounts: IAccount[]) => (
//   <Select name="destinationAccountNo" label="Destination Account" disabled>
//     {accounts.map(({ accountNumber }) => (
//       <SelectItem value={accountNumber} key={accountNumber}>
//         {accountNumber}
//       </SelectItem>
//     ))}
//   </Select>
// );

const renderNarrationField = () => (
  <Textarea name="narration" label="Narration" disabled />
);

const renderElevyField = () => (
  <AmountInput
    name="eLevyFee"
    label="E-Levy Fee"
    disabled
  />
);

export const renderBankField = (
  banks: IBank[],
) => (
  <Select
    name="destinationBankCode"
    label="Bank"
    disabled
  >
    {banks.map(({ name, code }) => (
      <SelectItem value={code} key={code}>
        {name}
      </SelectItem>
    ))}
  </Select>
);

export const renderScheduleForm = (
  submitting: boolean,
  dateFilterChange: (name: string, value?: string | null | undefined) => void,
  handleClearDateInput: (name: string, value?: string | null | undefined) => void,
) => (
  <>
    <Select name="frequency" label="Frequency" disabled={submitting}>
      {TransferFrequencyList.map(({ label, value }) => (
        <SelectItem value={value} key={value}>
          {label}
        </SelectItem>
      ))}
    </Select>
    <TableDatePicker
      name="specialDate"
      label="Special Date"
      onChange={dateFilterChange}
      onClickClear={handleClearDateInput}
      disabled={submitting}
    />
  </>
);

export const renderTransferTypeField = (
  types: ITransfersState['types'],
) => (
  <Select
    name="transferType"
    label="Transfer Type"
    disabled
  >
    {types.map(({ name, key }) => (
      <SelectItem value={key} key={key}>
        {name}
      </SelectItem>
    ))}
  </Select>
);

export const renderTransferFieldsFrom = (accounts: IAccount[]) => (
  <>
    {renderSourceAccountField(accounts)}
    {renderAmountField()}
  </>
);

export const renderAnotherBankTransferFieldsFrom = (accounts: IAccount[],
  values: IFormValues, types: ITransfersState['types']) => (
    <>
      {renderSourceAccountField(accounts)}
      {renderTransferTypeField(types)}
      {renderAmountField()}
      {values.transferType === 'INSTANT' && renderElevyField()}

    </>
);

export const renderBulkTransferFieldsFrom = (
  accounts: IAccount[],
  submitting: boolean,
  dateFilterChange: (name: string, value?: string | null | undefined) => void,
  handleClearDateInput: (name: string, value?: string | null | undefined) => void,
) => (
  <>
    {renderSourceAccountField(accounts)}
    {renderScheduleForm(submitting, dateFilterChange, handleClearDateInput)}
  </>
);

export const renderAccountNumberField = (
) =>
  (
    <>
      <Input
        name="destinationAccountNo"
        label="Account Number"
        disabled
      />
    </>
  );

export const renderOwnTransferFieldsTo = (
  accounts: IAccount[],
  values: IFormValues,
  submitting: boolean,
  dateFilterChange: (name: string, value?: string | null | undefined) => void,
  handleClearDateInput: (name: string, value?: string | null | undefined) => void,
) => (
  <>
    {renderAccountNumberField()}

    {renderNarrationField()}
    {renderScheduleForm(submitting, dateFilterChange, handleClearDateInput)}
  </>
);

export const renderNonInstantBeneficiaryNameField = (values: IFormValues) => {
  if (values.transferType !== 'NON_INSTANT') return null;

  return <Input name="beneficiaryName" label="Beneficiary Name" />;
};


export const renderFirstAtlanticTransferFieldsTo = (
  submitting: boolean,
  dateFilterChange: (name: string, value?: string | null | undefined) => void,
  handleClearDateInput: (name: string, value?: string | null | undefined) => void,
) => (
  <>
    {renderAccountNumberField()}

    {renderNarrationField()}
    {renderScheduleForm(submitting, dateFilterChange, handleClearDateInput)}
  </>
);

export const renderAnotherBankTransferFieldsTo = (
  submitting: boolean,
  dateFilterChange: (name: string, value?: string | null | undefined) => void,
  handleClearDateInput: (name: string, value?: string | null | undefined) => void,
  banks: ITransfersState['banks'],
  values: IFormValues,
) => (
  <>
    {renderBankField(banks)}
    {renderAccountNumberField()}
    {renderNonInstantBeneficiaryNameField(values)}
    {renderNarrationField()}
    {renderScheduleForm(submitting, dateFilterChange, handleClearDateInput)}
  </>
);
